/* eslint-disable */
// ─────────────────────────────────────────────────────────────────────────────
// AgendarDemo.jsx — Página "Agendar demonstração" IMOBMEET
// Transcrição fiel do bundle de produção (imobmeet-site.netlify.app).
// Formulário multi-etapas real (Rm), com webhook do CRM, componentes e helpers
// inline. Navbar/Footer compartilhados; globais (cookie/whatsapp) → () => null.
// ─────────────────────────────────────────────────────────────────────────────
import * as b from "react";
import * as n from "react/jsx-runtime";
import { Link as V } from "react-router-dom";
import { C, font, mono } from "../tokens";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { applySeo } from "../lib/seo";
import DemoStepsForm from "../components/DemoStepsForm";

// Aliases dos identificadores do bundle original.
const s = C, p = font, Pt = mono;
const _n = Navbar;   // Navbar compartilhada
const Hn = Footer;   // Footer compartilhado
const qn = () => null;

// ─── Layout wrapper ($r) ──────────────────────────────────
function $r({
    activeSolution: e,
    children: t
}) {
    return n.jsxs("div", {
        style: {
            background: s.surface,
            minHeight: "100vh",
            overflowX: "clip"
        },
        children: [n.jsx(_n, {
            activeSolution: e
        }), n.jsx("div", {
            style: {
                paddingTop: 72
            },
            children: t
        }), n.jsx(Hn, {}), n.jsx(qn, {})]
    })
}

// ─── Ícone check ──────────────────────────────────────────
const Io = ({
        size: e = 14
    }) => n.jsx("svg", {
        width: e,
        height: e,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "3",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: n.jsx("path", {
            d: "M20 6 9 17l-5-5"
        })
    }),
    Bd = {
        instagram: {
            label: "Instagram",
            bg: "#E4405F",
            path: n.jsxs(n.Fragment, {
                children: [n.jsx("rect", {
                    x: "2",
                    y: "2",
                    width: "20",
                    height: "20",
                    rx: "5.5",
                    fill: "none",
                    stroke: "currentColor",
                    strokeWidth: "2"
                }), n.jsx("circle", {
                    cx: "12",
                    cy: "12",
                    r: "4.2",
                    fill: "none",
                    stroke: "currentColor",
                    strokeWidth: "2"
                }), n.jsx("circle", {
                    cx: "17.6",
                    cy: "6.4",
                    r: "1.3",
                    fill: "currentColor"
                })]
            })
        },
        linkedin: {
            label: "LinkedIn",
            bg: "#0A66C2",
            path: n.jsx("path", {
                fill: "currentColor",
                d: "M4.98 3.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM3 9h4v12H3V9zm6 0h3.8v1.7h.1c.5-.95 1.8-1.95 3.6-1.95 3.9 0 4.6 2.55 4.6 5.85V21h-4v-5.3c0-1.27-.02-2.9-1.77-2.9-1.77 0-2.04 1.38-2.04 2.8V21H9V9z"
            })
        },
        facebook: {
            label: "Facebook",
            bg: "#1877F2",
            path: n.jsx("path", {
                fill: "currentColor",
                d: "M22 12a10 10 0 1 0-11.56 9.88v-6.99H7.9V12h2.54V9.8c0-2.5 1.49-3.89 3.78-3.89 1.09 0 2.24.2 2.24.2v2.46h-1.26c-1.24 0-1.63.77-1.63 1.56V12h2.78l-.44 2.89h-2.34v6.99A10 10 0 0 0 22 12z"
            })
        },
        youtube: {
            label: "YouTube",
            bg: "#FF0000",
            path: n.jsx("path", {
                fill: "currentColor",
                d: "M23 12s0-3.2-.41-4.74a2.5 2.5 0 0 0-1.76-1.76C19.3 5.1 12 5.1 12 5.1s-7.3 0-8.83.4A2.5 2.5 0 0 0 1.41 7.26C1 8.8 1 12 1 12s0 3.2.41 4.74a2.5 2.5 0 0 0 1.76 1.76c1.53.4 8.83.4 8.83.4s7.3 0 8.83-.4a2.5 2.5 0 0 0 1.76-1.76C23 15.2 23 12 23 12zM9.75 15.02V8.98L15.5 12l-5.75 3.02z"
            })
        }
    };

// ─── Seção de sucesso (Mm) ────────────────────────────────
function Mm({
    nome: e,
    telefone: t
}) {
    const r = `https://wa.me/${xo.whatsappNumber}?text=${encodeURIComponent(xo.whatsappMsg)}`,
        o = (e || "").trim().split(" ")[0],
        i = Object.entries(xo.social).filter(([a, l]) => l && Bd[a]);
    return n.jsx("section", {
        style: {
            background: `linear-gradient(180deg, ${s.heroFrom} 0%, ${s.heroTo} 100%)`,
            padding: "72px 28px"
        },
        children: n.jsxs("div", {
            style: {
                maxWidth: 760,
                margin: "0 auto",
                textAlign: "center"
            },
            children: [n.jsx("div", {
                style: {
                    width: 72,
                    height: 72,
                    borderRadius: "50%",
                    background: s.success,
                    color: "white",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    margin: "0 auto 24px",
                    boxShadow: "0 12px 30px rgba(16,185,129,0.35)"
                },
                children: n.jsx(Io, {
                    size: 34
                })
            }), n.jsxs("h1", {
                style: {
                    fontFamily: p,
                    fontSize: 40,
                    fontWeight: 800,
                    letterSpacing: -1.2,
                    color: s.text,
                    lineHeight: 1.08,
                    margin: "0 0 14px"
                },
                children: [o ? `Obrigado, ${o}!` : "Obrigado!", " Recebemos sua solicitação."]
            }), n.jsxs("p", {
                style: {
                    fontFamily: p,
                    fontSize: 17.5,
                    lineHeight: 1.6,
                    color: s.muted,
                    margin: "0 auto 36px",
                    maxWidth: 560
                },
                children: [n.jsx("b", {
                    style: {
                        color: s.text
                    },
                    children: "Em breve nosso time comercial entrará em contato!"
                }), " Enquanto isso você pode conhecer um pouco mais sobre o IMOBMEET CRM assistindo o vídeo abaixo."]
            }), n.jsx("div", {
                style: {
                    position: "relative",
                    width: "100%",
                    paddingTop: "56.25%",
                    borderRadius: 18,
                    overflow: "hidden",
                    border: `1px solid ${s.border}`,
                    background: "#000",
                    boxShadow: "0 24px 60px rgba(10,15,30,0.18)",
                    marginBottom: 40
                },
                children: n.jsx("iframe", {
                    src: `https://www.youtube.com/embed/${xo.videoId}?rel=0`,
                    title: "IMOBMEET — conheça a plataforma",
                    allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                    allowFullScreen: !0,
                    style: {
                        position: "absolute",
                        inset: 0,
                        width: "100%",
                        height: "100%",
                        border: "none"
                    }
                })
            }), n.jsxs("a", {
                href: r,
                target: "_blank",
                rel: "noopener noreferrer",
                style: {
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 11,
                    padding: "16px 30px",
                    borderRadius: 13,
                    textDecoration: "none",
                    background: "#25D366",
                    color: "#fff",
                    fontFamily: p,
                    fontSize: 16.5,
                    fontWeight: 700,
                    boxShadow: "0 14px 30px rgba(37,211,102,0.38)",
                    transition: "transform 0.2s"
                },
                onMouseEnter: a => {
                    a.currentTarget.style.transform = "translateY(-2px)"
                },
                onMouseLeave: a => {
                    a.currentTarget.style.transform = "translateY(0)"
                },
                children: [n.jsx("svg", {
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    fill: "currentColor",
                    children: n.jsx("path", {
                        d: "M17.47 14.38c-.3-.15-1.74-.86-2-.96-.27-.1-.46-.15-.65.15-.2.3-.75.95-.92 1.14-.17.2-.34.22-.63.07-.3-.15-1.25-.46-2.38-1.47-.88-.78-1.47-1.75-1.64-2.05-.17-.3-.02-.46.13-.6.13-.13.3-.34.45-.51.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.08-.15-.65-1.57-.9-2.15-.24-.56-.48-.48-.65-.49-.17-.01-.37-.01-.56-.01-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.48 0 1.46 1.06 2.88 1.21 3.08.15.2 2.1 3.2 5.08 4.49.71.31 1.26.49 1.69.62.71.23 1.36.2 1.87.12.57-.08 1.74-.71 1.98-1.4.24-.68.24-1.27.17-1.39-.07-.12-.27-.2-.56-.34z"
                    })
                }), "Falar agora no WhatsApp"]
            }), i.length > 0 && n.jsxs("div", {
                style: {
                    marginTop: 44
                },
                children: [n.jsx("p", {
                    style: {
                        fontFamily: p,
                        fontSize: 12,
                        fontWeight: 800,
                        letterSpacing: .6,
                        textTransform: "uppercase",
                        color: s.muted,
                        margin: "0 0 16px"
                    },
                    children: "Acompanhe o IMOBMEET nas redes"
                }), n.jsx("div", {
                    style: {
                        display: "flex",
                        gap: 14,
                        justifyContent: "center",
                        flexWrap: "wrap"
                    },
                    children: i.map(([a, l]) => {
                        const d = Bd[a];
                        return n.jsx("a", {
                            href: l,
                            target: "_blank",
                            rel: "noopener noreferrer",
                            "aria-label": d.label,
                            title: d.label,
                            style: {
                                width: 50,
                                height: 50,
                                borderRadius: 14,
                                background: s.surface,
                                border: `1px solid ${s.border}`,
                                color: d.bg,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                boxShadow: "0 6px 16px rgba(10,15,30,0.08)",
                                transition: "transform 0.2s, box-shadow 0.2s"
                            },
                            onMouseEnter: c => {
                                c.currentTarget.style.transform = "translateY(-3px)", c.currentTarget.style.boxShadow = "0 12px 24px rgba(10,15,30,0.14)"
                            },
                            onMouseLeave: c => {
                                c.currentTarget.style.transform = "translateY(0)", c.currentTarget.style.boxShadow = "0 6px 16px rgba(10,15,30,0.08)"
                            },
                            children: n.jsx("svg", {
                                width: "24",
                                height: "24",
                                viewBox: "0 0 24 24",
                                children: d.path
                            })
                        }, a)
                    })
                })]
            })]
        })
    })
}

// ─── Marquee de soluções (Md) ─────────────────────────────
function Md({
    items: e
}) {
    const t = [
        [],
        [],
        []
    ];
    return e.forEach((r, o) => t[o % 3].push(r)), n.jsx("div", {
        style: {
            display: "flex",
            flexDirection: "column",
            gap: 16,
            padding: "8px 0"
        },
        children: t.map((r, o) => {
            const i = [...r, ...r],
                a = o % 2 === 1;
            return n.jsx("div", {
                className: "logo-marquee",
                style: {
                    padding: "4px 0"
                },
                children: n.jsx("div", {
                    className: "logo-track",
                    style: {
                        gap: 14,
                        animationDirection: a ? "reverse" : "normal",
                        animationDuration: `${52+o*6}s`
                    },
                    children: i.map((l, d) => n.jsx("span", {
                        className: "sol-pill",
                        style: {
                            flexShrink: 0,
                            padding: "12px 26px",
                            borderRadius: 999,
                            border: `1.5px solid ${s.accentBorder}`,
                            background: s.surface,
                            color: s.text,
                            fontFamily: p,
                            fontSize: 16,
                            fontWeight: 700,
                            letterSpacing: -.2,
                            whiteSpace: "nowrap",
                            transition: "background 0.25s, color 0.25s, border-color 0.25s, transform 0.25s"
                        },
                        children: l
                    }, d))
                })
            }, o)
        })
    })
}

// ─── Dados / helpers do formulário ────────────────────────
const ca = "#0560FF",
    xo = {
        videoId: "I-pIGzpivQs",
        whatsappNumber: "5511995565777",
        whatsappMsg: "Olá! Acabei de solicitar uma demonstração no site e gostaria de adiantar a conversa.",
        social: {
            instagram: "https://www.instagram.com/imobmeet",
            linkedin: "https://www.linkedin.com/company/imobmeet",
            facebook: "https://www.facebook.com/imobmeet",
            youtube: "https://www.youtube.com/@imobmeet"
        }
    },
    xm = ["Demonstração de 30 minutos personalizada para a sua operação", "Diagnóstico da operação com um especialista do mercado imobiliário", "Proposta sob medida para incorporadoras, loteadoras e construtoras"],
    ym = [{
        i: "RA",
        bg: "linear-gradient(135deg,#0560FF,#7C3AED)",
        photo: "https://randomuser.me/api/portraits/men/32.jpg"
    }, {
        i: "MC",
        bg: "linear-gradient(135deg,#10B981,#0560FF)",
        photo: "https://randomuser.me/api/portraits/women/44.jpg"
    }, {
        i: "AS",
        bg: "linear-gradient(135deg,#F59E0B,#EF4444)",
        photo: "https://randomuser.me/api/portraits/men/52.jpg"
    }, {
        i: "LP",
        bg: "linear-gradient(135deg,#7C3AED,#03D4FF)",
        photo: "https://randomuser.me/api/portraits/women/68.jpg"
    }, {
        i: "JS",
        bg: "linear-gradient(135deg,#0EA5E9,#0560FF)",
        photo: "https://randomuser.me/api/portraits/men/76.jpg"
    }];


// ─── Página / formulário multi-etapas (Rm) ────────────────
function Rm() {
    const [i, a] = b.useState(!1),
        [dd, setDd] = b.useState({ nome: "", telefone: "" });
    return i ? n.jsxs($r, {
        children: [n.jsx(Mm, {
            nome: dd.nome,
            telefone: dd.telefone
        }), n.jsxs("section", {
            style: {
                background: s.surface,
                padding: "8px 0 52px",
                overflow: "hidden"
            },
            children: [n.jsx("p", {
                style: {
                    textAlign: "center",
                    fontSize: 12,
                    color: s.muted,
                    marginBottom: 26,
                    fontWeight: 800,
                    letterSpacing: .6,
                    textTransform: "uppercase",
                    fontFamily: p,
                    padding: "0 28px"
                },
                children: "Tudo o que sua operação imobiliária precisa"
            }), n.jsx(Md, {
                items: ["Funil de vendas", "Geração de contratos", "Integração com ERPs", "Inteligência Artificial", "Atendimento WhatsApp", "Gestão de Unidades", "Gestão de Reservas", "Disponibilidade de Unidades", "Simulador financeiro", "Geração de Propostas", "Assinatura Digital", "Digitalização de Documentos", "Gestão de Recebíveis", "Central de Pós-vendas", "Emissão de Boletos", "Split de Comissões", "Pagadoria", "Integração Bancária", "Vendas Online"]
            })]
        })]
    }) : n.jsxs($r, {
        children: [n.jsx("section", {
            style: {
                background: `linear-gradient(180deg, ${s.heroFrom} 0%, ${s.heroTo} 100%)`,
                padding: "72px 28px"
            },
            children: n.jsxs("div", {
                className: "agendar-grid",
                style: {
                    maxWidth: 1160,
                    margin: "0 auto",
                    display: "grid",
                    gridTemplateColumns: "1.05fr 0.95fr",
                    gap: 56,
                    alignItems: "start"
                },
                children: [n.jsxs("div", {
                    children: [n.jsx("h1", {
                        style: {
                            fontFamily: p,
                            fontSize: 46,
                            fontWeight: 800,
                            letterSpacing: -1.4,
                            color: s.text,
                            lineHeight: 1.05,
                            margin: "0 0 18px",
                            maxWidth: 540
                        },
                        children: "Veja o IMOBMEET CRM aplicado à sua operação"
                    }), n.jsx("p", {
                        style: {
                            fontFamily: p,
                            fontSize: 18,
                            lineHeight: 1.65,
                            color: s.muted,
                            margin: "0 0 32px",
                            maxWidth: 500
                        },
                        children: "Agende uma conversa com um especialista e descubra como vender mais e gerenciar melhor seus empreendimentos."
                    }), n.jsx("div", {
                        style: {
                            display: "flex",
                            flexDirection: "column",
                            gap: 14,
                            marginBottom: 36
                        },
                        children: xm.map((y, j) => n.jsxs("div", {
                            style: {
                                display: "flex",
                                alignItems: "flex-start",
                                gap: 12
                            },
                            children: [n.jsx("span", {
                                style: {
                                    flexShrink: 0,
                                    width: 24,
                                    height: 24,
                                    borderRadius: 8,
                                    background: `${ca}1A`,
                                    color: ca,
                                    marginTop: 1,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center"
                                },
                                children: n.jsx(Io, {})
                            }), n.jsx("span", {
                                style: {
                                    fontFamily: p,
                                    fontSize: 15.5,
                                    lineHeight: 1.5,
                                    color: s.text,
                                    fontWeight: 500
                                },
                                children: y
                            })]
                        }, j))
                    }), n.jsxs("div", {
                        style: {
                            display: "flex",
                            alignItems: "center",
                            gap: 16,
                            flexWrap: "wrap",
                            padding: "16px 20px",
                            borderRadius: 14,
                            background: s.surface,
                            border: `1px solid ${s.border}`,
                            boxShadow: "0 8px 24px rgba(10,15,30,0.05)"
                        },
                        children: [n.jsx("div", {
                            style: {
                                display: "flex",
                                alignItems: "center"
                            },
                            children: ym.map((y, j) => n.jsxs("span", {
                                style: {
                                    position: "relative",
                                    width: 40,
                                    height: 40,
                                    borderRadius: "50%",
                                    marginLeft: j === 0 ? 0 : -12,
                                    border: "2px solid #fff",
                                    background: y.bg,
                                    boxShadow: "0 3px 8px rgba(10,15,30,0.14)",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    color: "#fff",
                                    fontFamily: p,
                                    fontSize: 13,
                                    fontWeight: 800,
                                    overflow: "hidden"
                                },
                                children: [y.i, n.jsx("img", {
                                    src: y.photo,
                                    alt: y.name,
                                    loading: "lazy",
                                    onError: w => {
                                        w.currentTarget.style.display = "none"
                                    },
                                    style: {
                                        position: "absolute",
                                        inset: 0,
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                        borderRadius: "50%"
                                    }
                                })]
                            }, j))
                        }), n.jsx("span", {
                            style: {
                                fontFamily: p,
                                fontSize: 14.5,
                                fontWeight: 700,
                                color: s.text
                            },
                            children: "+10 Estados Brasileiros"
                        })]
                    })]
                }), n.jsx("div", {
                    style: {
                        background: s.surface,
                        border: `1px solid ${s.border}`,
                        borderRadius: 20,
                        padding: 32,
                        boxShadow: "0 20px 60px rgba(10,15,30,0.10)"
                    },
                    children: n.jsx(DemoStepsForm, { onSubmitted: y => { setDd({ nome: y.nome, telefone: y.telefone }), a(!0) } })
                })]
            })
        }), n.jsxs("section", {
            style: {
                background: s.surface,
                padding: "8px 0 52px",
                overflow: "hidden"
            },
            children: [n.jsx("p", {
                style: {
                    textAlign: "center",
                    fontSize: 12,
                    color: s.muted,
                    marginBottom: 26,
                    fontWeight: 800,
                    letterSpacing: .6,
                    textTransform: "uppercase",
                    fontFamily: p,
                    padding: "0 28px"
                },
                children: "Tudo o que sua operação imobiliária precisa"
            }), n.jsx(Md, {
                items: ["Funil de vendas", "Geração de contratos", "Integração com ERPs", "Inteligência Artificial", "Atendimento WhatsApp", "Gestão de Unidades", "Gestão de Reservas", "Disponibilidade de Unidades", "Simulador financeiro", "Geração de Propostas", "Assinatura Digital", "Digitalização de Documentos", "Gestão de Recebíveis", "Central de Pós-vendas", "Emissão de Boletos", "Split de Comissões", "Pagadoria", "Integração Bancária", "Vendas Online"]
            })]
        })]
    })
}

export default function AgendarDemo() {
    b.useEffect(() => {
        applySeo({
            title: "Agendar demonstração do IMOBMEET CRM | IMOBMEET",
            description: "Agende uma demonstração gratuita do IMOBMEET CRM e veja como vender mais e gerenciar melhor sua incorporadora ou loteadora, do lead ao contrato.",
            keywords: "demonstração CRM imobiliário, agendar demo IMOBMEET, teste CRM incorporadora, CRM loteadora",
            path: "/agendar-demo"
        });
        window.scrollTo(0, 0);
    }, []);
    return n.jsx(Rm, {});
}
